//
// locales/vanilla/es.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/es.json';
import localeData from 'react-intl/locale-data/es.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
